import client from "./client.js";

export const fetchTeams = () => client.get("/teams").then((r) => r.data.data);

export const fetchTeam = (id) =>
  client.get(`/teams/${id}`).then((r) => r.data.data);

export const createTeam = (payload) =>
  client.post("/teams", payload).then((r) => r.data.data);

export const updateTeam = (id, payload) =>
  client.patch(`/teams/${id}`, payload).then((r) => r.data.data);

export const deleteTeam = (id) => client.delete(`/teams/${id}`);

export const addTeamMember = (id, payload) =>
  client.post(`/teams/${id}/members`, payload).then((r) => r.data.data);

export const removeTeamMember = (id, userId) =>
  client.delete(`/teams/${id}/members/${userId}`);
